import * as React from 'react';
import { History } from 'history';
import Model from './transactiondetail-model';
import BaseList from '../base/base-list.component';

interface IProps { 
  history: History;
  root?: string;
  productId?: number;
  transactionId?: number;
  transactionStatus?: string;
  actions?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
  onLoad?: (data: any) => void;
  onLoadAll?: (data: any) => void;
}

interface IState {
}

export default class TransactiondetailList extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
  }

  private onLoadAll = (data: any) => {
    const total = data?.reduce((v: number, d: any) => { return v + d.value * d.qty}, 0);
    this.props.onLoadAll?.({'data': data, 'total': total});
  }

  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} parentId={this.props.transactionId} endPointFilter={Model.endPointFilterList(this.props.productId, this.props.transactionId, this.props.transactionStatus)} url={(this.props.root || '') + Model.url} model={Model} onLoad={this.props.onLoad} onLoadAll={this.onLoadAll} actions={this.props.actions} disableBackButton={this.props.disableBackButton } disableCard={this.props.disableCard}/>
    );
  }
}
